import "./_engagement.scss";

import {useContext, useEffect, useState} from "react";
import {useFieldArray, UseFieldArrayRemove} from "react-hook-form";

import iconAdd from "@/assets/massification/iconAdd.svg";
import iconTrash from "@/assets/massification/iconTrash.svg";
import AdresseSelect from "@/components/AdresseSelect/AdresseSelect";
import Button from "@/components/Button/Button";
import {HookFormContext} from "@/context/HookFormContext";
import {findLivraisonDate} from "@/function/engagementTools";
import {formatDate} from "@/function/formatDate";
import {Adresse} from "@/ts/interface/compte";
import {Option} from "@/ts/interface/detailOffre";
import {CreateEngagement} from "@/ts/interface/detailOffre";
import {Livraison} from "@/ts/interface/detailOffre";
import {Article} from "@/ts/interface/detailOffre";
import {MultiSeletcOption} from "@/ts/interface/formulaire";

import MultiSelect from "../MultiSelect/MultiSelect";
import ArticleSelect from "./ArticleSelect";

function EngagementElement({
  adresses,
  indexEngagement,
  removeEngagement,

  options,
  livraisons,
  offreArticles,
}: {
  adresses?: Adresse[];
  removeEngagement: UseFieldArrayRemove;

  indexEngagement: number;
  options: Option[];
  livraisons: Livraison[];
  offreArticles: Article[];
}): JSX.Element {
  const context = useContext(HookFormContext);

  if (!context) {
    throw new Error("HookFormContext is not provided.");
  }

  const {watch, setValue, control, getValues} = context;

  const {
    fields: fieldArticles,
    append: appendArticle,
    remove: removeArticle,
    update: updateArticle,
  } = useFieldArray({
    control,
    name: `engagements[${indexEngagement}].articles`,
  });

  const engagement: CreateEngagement = getValues(
    `engagements[${indexEngagement}]`,
  );

  // date de livraison par defaut, a partir du première article et du premier fournisseur
  const [selectedDateLivraison, setSelectedDateLivraison] = useState<string[]>(
    [],
  );
  useEffect(() => {
    const dateLivraison = findLivraisonDate(
      livraisons,
      engagement?.articles?.[0]?.article_id,
    );
    setSelectedDateLivraison([dateLivraison]);
  }, []);
  const livraisonsOptions: MultiSeletcOption[] =
    livraisons[0].fournisseurs[0].dates_livraison.map(livraison => {
      const date_debut = formatDate(livraison.debut);
      const date_fin = formatDate(livraison.fin);
      return {
        libelle: `Du ${date_debut} au ${date_fin}`,
        value: livraison.fin,
        defaultChecked: selectedDateLivraison.includes(livraison.fin),
      };
    });

  // on filtre les doublons pour ne pas les afficher.
  const ChoixArticlesQuantite: JSX.Element[] | undefined = fieldArticles.map(
    (article: any, index) => {
      return (
        <ArticleSelect
          key={index + article.article_id}
          options={options}
          offreArticles={offreArticles}
          removeArticle={removeArticle}
          nameHookForm={`.engagements[${indexEngagement}].articles[${index}]`}
          selectedArticle={
            fieldArticles as unknown as {article_id: number; quantite: number}[]
          }
          updateArticle={updateArticle}
          articleIndex={index}
          indexEngagement={indexEngagement}
        />
      );
    },
  );

  const handleAddArticle = (): void => {
    const indexOffreArticles = offreArticles.findIndex(offreArticle => {
      let isFind = false;
      fieldArticles.forEach((article: any) => {
        isFind = article.article_id != offreArticle.article_id;
      });
      return isFind;
    });
    console.log(indexOffreArticles);
    appendArticle({
      article_id: offreArticles[indexOffreArticles].article_id,
      quantite: 1,
    });
  };

  return (
    <div className="engagement-info">
      <div className="engagement-info--content">
        <div className="engagement-articles">
          {ChoixArticlesQuantite}
          {fieldArticles.length < offreArticles.length ? (
            <Button
              onClick={() => handleAddArticle()}
              type="button"
              label="Ajouter un article"
              variant="secondary"
              icon={iconAdd}
            />
          ) : null}
        </div>
        <div className="engagement-livraisonDate">
          <MultiSelect
            label={"Choisir vos dates de livraison"}
            options={livraisonsOptions}
            needMin1Check={true}
            watch={watch}
            setValue={setValue}
            control={control}
            name={`engagements[${indexEngagement}].dates_livraisons`}
            uniqueKey={`engagements[${indexEngagement}].dates_livraisons`}
            onClick={() => {}}
          />
        </div>
        <div className="engagement-adresse">
          {adresses ? (
            <AdresseSelect
              adressesList={adresses}
              nameFormChamp={`.engagements[${indexEngagement}]`}
            />
          ) : null}
        </div>
      </div>

      {indexEngagement > 0 ? (
        <Button
          icon={iconTrash}
          label=""
          variant="circle secondary icon"
          className="engagement-delete"
          onClick={() => removeEngagement(indexEngagement)}
        />
      ) : null}
    </div>
  );
}

export default EngagementElement;
